
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12771',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12771",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.486",
  "data-fetching-client": "static-1.9795",
  "foundations-components": "static-1.8203",
  "foundations-components-legacy": "static-1.1228",
  "foundations-theming": "static-1.4569",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8155",
  "hub-http-shared-msw-handlers": "static-1.10300",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11606",
  "I18n": "static-7.1642",
  "jasmine-runner": "static-1.6592",
  "marketplace-storefront-base": "static-1.12834",
  "quartz": "static-1.7211",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16821",
  "reactive-variable-buffer-atom": "static-1.2992",
  "reporting-testing-lib": "static-1.10036",
  "reselect": "static-3.6",
  "settings-ui-lib": "static-1.12657",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7386",
  "ui-addon-i18n": "static-1.11284",
  "ui-addon-react-router-dom": "static-1.9671",
  "unified-auth": "static-1.655",
  "unified-auth-core-lib": "static-1.937",
  "usage-tracker": "static-1.7486",
  "usage-tracker-core": "static-1.7336",
  "customer-data-property-utils": "static-1.8230",
  "hub-http": "static-1.6357",
  "integrations-lib": "static-1.16580",
  "marketplace-ui-common": "static-1.20217",
  "property-management-iframe": "static-1.13614",
  "quartz-config": "static-1.989",
  "quartz-core": "static-1.6430",
  "quartz-routing": "static-1.641",
  "quick-fetch": "static-1.4020",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4792",
  "ts-schema": "static-1.4184",
  "ui-universal-auth": "static-1.9141",
  "UIComponents": "static-3.8552",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3501",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3488",
  "quartz-webpack": "static-1.3435",
  "bend-plugin-quartz-routing": "static-1.289",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4472",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.5009",
  "foundations-theming-specialty": "static-1.2285",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9558",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.40",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5443",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2221",
  "ui-fonts": "static-1.868",
  "ui-images": "static-2.1191",
  "bend-plugin-foundations-theming": "static-1.3052",
  "foundations-theming-base": "static-1.3554",
  "stylex": "static-1.35",
  "HeadJS": "static-2.774",
  "hs-test-utils-bend-plugin": "static-1.3266",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4460",
  "ai-components-ui-library": "static-1.9291",
  "ai-rendering-library": "static-1.10665",
  "chirp-fetch": "static-1.2023",
  "connections-embed-lib": "static-1.1253",
  "copilot-toolkit": "static-1.11482",
  "feedback-loader": "static-1.29552",
  "laboratory-lib": "static-3.7287",
  "marketplace-embed": "static-1.22507",
  "marketplace-ui-details": "static-1.10112",
  "marketplace-ui-reviews": "static-1.20172",
  "marketplace-ui-tracking": "static-1.14387",
  "sanitize-text": "static-1.8282",
  "ui-addon-video-player": "static-1.8840",
  "usage-tracker-multi": "static-1.5900",
  "usage-tracker-session-replay": "static-1.5172",
  "wootric-nps": "static-1.7084",
  "quartz-head": "static-1.876",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4786",
  "immer": "static-1.33",
  "immerable": "static-1.4285",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2582",
  "reporting-data": "static-1.68103",
  "cssUtils": "static-1.833",
  "flux-actions": "static-1.349",
  "HubStyle": "static-2.11913",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10342",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10497",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7476",
  "icons": "static-2.657",
  "marketplace-ui-apps-core": "static-1.18749",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4644",
  "foundations-components-test-utils": "static-1.5686",
  "quartz-i18n": "static-1.886",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.73",
  "ads-unified-auth-lib": "static-1.501",
  "google-sheets-integration-lib": "static-1.634",
  "microsoft-drive-integration-lib": "static-1.798",
  "surveymonkey-integration-lib": "static-1.91",
  "slack-ui-library": "static-1.10532",
  "fsm": "static-1.3866",
  "customer-data-objects": "static-1.7814",
  "property-translator": "static-1.5532",
  "hs-locale-management": "static-1.183",
  "frontend-preferences-client": "static-1.8062",
  "hs-promise-utils": "static-1.5729",
  "hubspot-apollo-client": "static-1.5012",
  "integrations-error-boundary-lib": "static-1.13995",
  "integrations-tracking-lib": "static-1.5742",
  "native-integrations-shared-strings": "static-1.7916",
  "sanitize": "static-1.4612",
  "superstore": "static-1.4895",
  "ui-shepherd-react": "static-3.10392",
  "ai-settings-ui-library": "static-1.8106",
  "hub-http-janus": "static-1.849",
  "hubspotter-http": "static-1.4753",
  "immutable-less": "static-1.4787",
  "marketplace-ui-client-types": "static-1.17624",
  "nav-meta": "static-1.29968",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18177",
  "inbound-db-properties-service-client": "static-1.3948",
  "property-management-common": "static-1.5902",
  "ui-addon-iframeable": "static-1.9203",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.548",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.886",
  "quartz-test": "static-1.886",
  "quartz-tracking": "static-1.590",
  "trellis-components": "static-1.2240",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.202",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21956",
  "ContentUtils": "static-1.68760",
  "customer-data-objects-ui-components": "static-1.13164",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2633",
  "breeze-engine-core": "static-1.462",
  "breeze-onboarding-components": "static-1.304",
  "customer-data-filters-ui": "static-1.40272",
  "customer-data-reference-ui-components": "static-1.13310",
  "embedded-academy-lib": "static-1.14795",
  "ExportDialog": "static-6.10514",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41643",
  "reporting-snowflake": "static-1.56721",
  "reporting-ui-components": "static-2.65374",
  "reporting-visualizations": "static-1.60179",
  "trellis-theming": "static-1.1078",
  "ui-addon-teams": "static-1.21725",
  "integrations-reconnect-lib": "static-1.226",
  "magpie-lib": "static-1.5642",
  "navigation-components": "static-1.18331",
  "breeze-engine-lib": "static-1.1184",
  "magpie-types": "static-1.5102",
  "simple-logging-lib": "static-1.3184",
  "ai-studio-lib": "static-1.12012",
  "app-governance-lib": "static-1.1978",
  "developer-experience-shared-components": "static-1.10661",
  "hubspot-prosemirror": "static-1.18619",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8145",
  "ui-product-approvals": "static-1.28673",
  "ui-tool-access": "static-1.10286",
  "usage-based-billing-components-lib": "static-1.9508",
  "usage-tracker-anonymous": "static-1.5903",
  "usage-tracker-public": "static-1.7297",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3689",
  "persist-promise": "static-1.3836",
  "reference-resolvers": "static-1.8311",
  "ui-extensibility-client-types": "static-1.4059",
  "hubspot-apollo-cache": "static-1.471",
  "universal-page-editor-lib": "static-1.3146",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3157",
  "atom": "static-1.5211",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6119",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1679",
  "crm-component-utils": "static-1.39435",
  "crm-properties-common-lib": "static-1.6025",
  "customer-data-properties": "static-1.52017",
  "framework-data-schema-resolvers": "static-1.7029",
  "property-value-citations": "static-1.2631",
  "reference-resolvers-lite": "static-1.8231",
  "ui-business-units-lib": "static-1.9205",
  "navigation-messaging": "static-1.7658",
  "hubspotter-http-shared-msw-handlers": "static-1.10298",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4950",
  "content-icons-ui": "static-1.2267",
  "customer-data-ui-utilities": "static-1.9959",
  "conversations-skeleton-state": "static-1.7382",
  "crm-message-bus": "static-1.43345",
  "customer-data-filters-ui-msw-helpers": "static-1.22707",
  "events-data-lib": "static-1.370",
  "FormUrlGenerator": "static-2.4857",
  "framework-builder-read-service-client": "static-1.4107",
  "framework-data-schema-quick-fetch": "static-1.6934",
  "multi-account-reference-resolvers": "static-1.1117",
  "onboarding-tours": "static-1.16865",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14068",
  "academy-common-lib": "static-1.14255",
  "content-assistance-lib": "static-1.7971",
  "dashboard-lib": "static-1.82052",
  "file-manager-components": "static-1.24023",
  "getting-started-shared-tasks": "static-1.18789",
  "hubspot-prosemirror-plugins": "static-1.18611",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20069",
  "share-with-third-party-component-lib": "static-1.8839",
  "ui-addon-draggable": "static-3.4895",
  "ui-asset-management-lib": "static-1.11212",
  "user-context": "static-1.5243",
  "growth-payments-core": "static-1.25774",
  "reporting-plugins": "static-1.10534",
  "reporting-reports": "static-1.67781",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.861",
  "nest": "static-1.367",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10762",
  "framework-listing-lib": "static-2.29071",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31017",
  "apps-service-types": "static-1.3936",
  "oauth-service-types": "static-1.4389",
  "content-media-capture": "static-1.4934",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23858",
  "ui-addon-emoji-picker": "static-1.10020",
  "video-components-external": "static-1.11730",
  "video-data-lib": "static-1.35388",
  "react-dnd-compat": "static-1.4749",
  "ui-product-approvals-common": "static-1.568",
  "onboarding-scopes": "static-1.6595",
  "onboarding-tours-client": "static-1.5079",
  "platform-infra-nav-components": "static-1.7776",
  "subscription-experience-data-types": "static-1.15087",
  "crm-record-cards-service-types": "static-1.3687",
  "location-customization-utils-lib": "static-1.9645",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6122",
  "signup-constants": "static-1.19196",
  "signup-ui-url-generator": "static-2.8193",
  "card-properties-lib": "static-1.44600",
  "commerce-subscription-lib": "static-1.37466",
  "crm-actions": "static-1.6475",
  "crm-cards-sdk": "static-1.43996",
  "customer-data-properties-shared-msw-handlers": "static-1.9627",
  "customer-data-tracking": "static-1.7021",
  "hs-resources": "static-1.313",
  "pulse": "static-1.740",
  "calling-global-api": "static-1.64953",
  "calling-internal-common": "static-1.31447",
  "calling-lifecycle-internal": "static-1.66335",
  "calling-lifecycle-messages": "static-1.58629",
  "commerce-products-lib": "static-1.10067",
  "conditional-properties-service-client": "static-1.3900",
  "crm-links": "static-1.6444",
  "crm-pipelines-api-client-types": "static-1.4239",
  "external-options-client-types": "static-1.4229",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4319",
  "meetings-icalendar-utils-lib": "static-1.768",
  "multi-currency-client-types": "static-1.3793",
  "object-builder-ui-client": "static-1.49214",
  "pipeline-validation-client-types": "static-1.4068",
  "smart-property-lib": "static-1.7957",
  "tiered-pricing": "static-1.1577",
  "topics-actions-lib": "static-1.221",
  "ui-addon-form-validation": "static-1.11126",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.148",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1235",
  "growth-data-modal": "static-1.5655",
  "growth-onboarding-confetti": "static-1.3201",
  "growth-onboarding-next-action-utils": "static-1.2306",
  "onboarding-tours-utils": "static-1.931",
  "ui-shepherd-tracker": "static-1.7773",
  "academy-service-client": "static-1.3819",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39522",
  "FileManagerLib": "static-1.39663",
  "SafeStorage": "static-1.4535",
  "video-embed": "static-1.36222",
  "ui-coaching-tips": "static-1.28936",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24670",
  "viral-links-lib": "static-1.7205",
  "data-token-picker": "static-1.16650",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.374",
  "timezone-utils": "static-2.5378",
  "seat-types-lib": "static-1.311",
  "getting-started-shared-tasks-store": "static-1.17907",
  "ui-addon-opt": "static-4.8497",
  "campaign-roi-lib": "static-1.9512",
  "ui-addon-calendars": "static-2.5457",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25726",
  "framework-data-table": "static-2.12222",
  "marketing-platform-lib": "static-1.7001",
  "nudge-client-utils": "static-1.2875",
  "nudge-custom-ui-functions": "static-1.1271",
  "switchboard-lib": "static-1.361",
  "app-users-service-client": "static-1.5747",
  "app-users-service-types": "static-1.5155",
  "mini-checkout-client": "static-1.27136",
  "onboarding-utils": "static-1.5493",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28921",
  "content-media-composition-data-lib": "static-1.12738",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4561",
  "commerce-tours-lib": "static-1.6356",
  "growth-onboarding-reliability": "static-1.5216",
  "sales-checkout-service-client": "static-1.3723",
  "content-media-compositions": "static-2.16745",
  "media-bridge-lib": "static-1.19165",
  "edison-service-client-types": "static-1.523",
  "crm_data": "static-4.92391",
  "customer-data-sidebar": "static-2.46386",
  "enrichment-properties-lib": "static-1.17075",
  "ui-addon-draggable-compat": "static-2.4395",
  "universal-record-utils-lib": "static-1.1310",
  "commerce-billing-lib": "static-1.19533",
  "commerce-shared-components-lib": "static-1.18880",
  "commerce-tools-ui-lib": "static-1.10733",
  "crm-fe-perf": "static-1.23036",
  "event-emitter": "static-1.1085",
  "bend-plugin-pulse": "static-1.243",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31454",
  "shared-worker-versioning": "static-1.11170",
  "calling-usage-tracker": "static-1.6678",
  "voice-sms-access-library": "static-1.1494",
  "commerce-permissions": "static-1.910",
  "products-iframe-lib": "static-1.8305",
  "products-ui-components-shared-msw-handlers": "static-1.10682",
  "data-agent-kit": "static-1.422",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10383",
  "policy-lib": "static-1.6921",
  "react-tinymce": "static-1.55602",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10446",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54728",
  "tinymce-plugins": "static-1.57842",
  "tinymce-themes": "static-1.56698",
  "onboarding-data-sync-lib": "static-1.2206",
  "growth-onboarding-next-action-components": "static-1.2334",
  "user-context-client": "static-1.4714",
  "audio-components": "static-1.6127",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37174",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4670",
  "video-components": "static-1.13732",
  "outpost": "static-1.4304",
  "growth-onboarding-feedback-components": "static-1.6714",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21917",
  "sales-email-signature-service-client": "static-1.3985",
  "ts-utils-lib": "static-1.309",
  "crm-export-dialog": "static-1.6419",
  "crm-index-associations-lib": "static-1.6576",
  "crm-view-components": "static-1.684",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7467",
  "nudge-custom-function-registry": "static-1.2632",
  "nudge-renderer-utils": "static-1.2951",
  "whisper-core-api": "static-1.6920",
  "InboxConnectUtils": "static-4.15179",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5847",
  "settings-content-modals": "static-1.46465",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22251",
  "customer-data-email": "static-1.18278",
  "card-payment-highlight-lib": "static-1.37557",
  "card-subscription-highlight-lib": "static-1.39889",
  "commerce-contract-lib": "static-1.12701",
  "invoices-highlight-card-lib": "static-1.55164",
  "orders-highlight-card-lib": "static-1.21838",
  "products-highlight-card-lib": "static-1.18350",
  "quotes-highlight-card-lib": "static-1.72468",
  "crm-source-interpretation-lib": "static-1.5466",
  "crm-object-search-query-utilities": "static-1.9883",
  "utility-belt": "static-1.2667",
  "payments-enrollment-embed-lib": "static-1.23329",
  "stripe-embedded-components": "static-1.7752",
  "customer-data-rte": "static-1.33344",
  "cv-backend-services": "static-1.1571",
  "growth-onboarding-empty-states": "static-1.5998",
  "payments-post-enroll-local-storage-lib": "static-1.5241",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38558",
  "trials-service-types": "static-1.4018",
  "calling-orchestration-schema": "static-1.36271",
  "sales-views-client-types": "static-1.4392",
  "hub-http-contrib": "static-1.3178",
  "interframe": "static-3.4894",
  "tinymce-data": "static-1.40813",
  "ui-addon-sales-email": "static-1.5345",
  "layout-dnd-components": "static-1.12714",
  "layout-dnd-utils": "static-1.11689",
  "ui-brand-identity-lib": "static-1.15772",
  "NamespacedHubStyle": "static-2.9156",
  "meetings-connect-utils-lib": "static-1.7740",
  "social-insights-client-types": "static-1.22406",
  "crm-index-visualization-core": "static-1.4310",
  "checkout-sdk": "static-3.23979",
  "company-details-components": "static-1.6332",
  "payment-method-components": "static-1.7002",
  "pricing-pages-ui-components": "static-1.14797",
  "quote-checkout-service-types": "static-1.3600",
  "upgrade-catalog-service-types": "static-1.3655",
  "access-control-lib": "static-1.10572",
  "EmailComponents": "static-1.55152",
  "EmailData": "static-1.53829",
  "redux-less": "static-2.9618",
  "sequences-lib": "static-1.8273",
  "ui-gdpr-components": "static-1.10487",
  "products-ui-components": "static-1.40585",
  "accounting-integrations-ui-components": "static-1.7288",
  "invoices-ui-lib": "static-1.55180",
  "commerce-products-api": "static-1.2491",
  "invoices-iframe-lib": "static-1.57238",
  "quotes-modal-lib": "static-1.103146",
  "quotes-ui-lib": "static-1.81189",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28610",
  "ContentData": "static-1.68835",
  "layout-data-lib": "static-1.10014",
  "checkout-service-types": "static-1.3899",
  "hub-http-rxjs": "static-1.815",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4072",
  "billing-payments-client-types": "static-1.4125",
  "react-performance-metrics-lib": "static-1.692",
  "pricing-pages-api": "static-1.14662",
  "ContentComponents": "static-2.71716",
  "marketing-contacts-lib": "static-1.10497",
  "marketing-email-service-types": "static-1.2005",
  "messaging-editing-lib": "static-1.46671",
  "messaging-usage-based-billing-components-lib": "static-1.1533",
  "automation-ui-source-apps": "static-1.19272",
  "automation-ui-types": "static-1.20190",
  "messaging-types-lib": "static-1.46408",
  "onboarding-settings-client": "static-1.4640",
  "sequences-client-types-lib": "static-1.8130",
  "commerce-tax-lib": "static-1.671",
  "price-books-api": "static-1.1298",
  "price-books-components": "static-1.1356",
  "property-description-translator": "static-1.3976",
  "ramp-editor": "static-1.511",
  "commerce-analytics-service-client": "static-1.3711",
  "totals-ui-components": "static-1.23962",
  "SalesContentIndexUI": "static-3.9436",
  "advanced-menus-core": "static-1.15357",
  "advanced-menus-lib": "static-1.12265",
  "ui-memberships-settings-lib": "static-1.34410",
  "segments-query-core": "static-1.1555",
  "automation-ui-ubb": "static-1.6106",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7473",
  "data-token-views": "static-1.16631",
  "forms-utils-lib": "static-1.12842",
  "payments-embed-points-lib": "static-1.13316",
  "simple-menus-core": "static-1.15356",
  "simple-menus-lib": "static-1.16873",
  "videoconference-integration-components": "static-1.7029",
  "mc-hard-limits-client-types": "static-1.34",
  "marketing-contacts-client": "static-1.7645",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77477",
  "short-messages-app-service-client": "static-1.4057",
  "web-interactives-components": "static-1.13999",
  "web-interactives-data": "static-1.14000",
  "messaging-shared-utils-lib": "static-1.982",
  "messaging-user-info-utils-lib": "static-1.1152",
  "email-portal-health-service-types": "static-1.1112",
  "line-items-api": "static-1.889",
  "commerce-totals-service-types": "static-1.3920",
  "FireAlarmUi": "static-1.4610",
  "sales-templates-service-types-lib": "static-1.4271",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22126",
  "automation-ui-usage-tracking": "static-1.21589",
  "data-studio-ubb": "static-1.3112",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27330",
  "collaboration-sidebar": "static-1.58252",
  "content-management-data-lib": "static-1.5656",
  "copilot-plugins": "static-1.11455",
  "cta-picker": "static-1.36752",
  "customer-agent-discovery-components-lib": "static-1.3469",
  "editor-components": "static-1.13430",
  "editor-iframe-lib": "static-1.8595",
  "error-messaging-js": "static-1.5329",
  "FormsCommonComponents": "static-1.86182",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10782",
  "SharedLegalStrings": "static-1.1880",
  "smart-content-core": "static-1.42811",
  "smart-content-lib": "static-1.43464",
  "social-composer-lib": "static-1.59634",
  "structured-content-lib": "static-1.25553",
  "theme-previewer-lib": "static-1.53613",
  "tinymce-copilot": "static-1.16796",
  "xray-recommendation-lib": "static-1.8080",
  "automation-ui-routing": "static-1.21547",
  "sql-reporting-client-types": "static-1.5750",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42488",
  "campaigns-utils-lib": "static-1.3329",
  "reporting-enablement": "static-1.23375",
  "chatspot-widget-iframe": "static-1.21947",
  "collaboration-sidebar-common": "static-1.3049",
  "forms-ai-lib": "static-1.4534",
  "codemirror-dlb": "static-1.59036",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6570",
  "report-customization-components": "static-1.13534",
  "data-quality-ui-library": "static-1.13392",
  "reporting-filters": "static-1.658",
  "reporting-insights-lib": "static-1.2140"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12771",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.486",
  "data-fetching-client": "/data-fetching-client/static-1.9795",
  "foundations-components": "/foundations-components/static-1.8203",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1228",
  "foundations-theming": "/foundations-theming/static-1.4569",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8155",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10300",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11606",
  "I18n": "/I18n/static-7.1642",
  "jasmine-runner": "/jasmine-runner/static-1.6592",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12834",
  "quartz": "/quartz/static-1.7211",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16821",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2992",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10036",
  "reselect": "/reselect/static-3.6",
  "settings-ui-lib": "/settings-ui-lib/static-1.12657",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7386",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11284",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9671",
  "unified-auth": "/unified-auth/static-1.655",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.937",
  "usage-tracker": "/usage-tracker/static-1.7486",
  "usage-tracker-core": "/usage-tracker-core/static-1.7336",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8230",
  "hub-http": "/hub-http/static-1.6357",
  "integrations-lib": "/integrations-lib/static-1.16580",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20217",
  "property-management-iframe": "/property-management-iframe/static-1.13614",
  "quartz-config": "/quartz-config/static-1.989",
  "quartz-core": "/quartz-core/static-1.6430",
  "quartz-routing": "/quartz-routing/static-1.641",
  "quick-fetch": "/quick-fetch/static-1.4020",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4792",
  "ts-schema": "/ts-schema/static-1.4184",
  "ui-universal-auth": "/ui-universal-auth/static-1.9141",
  "UIComponents": "/UIComponents/static-3.8552",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3501",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3488",
  "quartz-webpack": "/quartz-webpack/static-1.3435",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.289",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4472",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.5009",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2285",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9558",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.40",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5443",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2221",
  "ui-fonts": "/ui-fonts/static-1.868",
  "ui-images": "/ui-images/static-2.1191",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3052",
  "foundations-theming-base": "/foundations-theming-base/static-1.3554",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.774",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3266",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4460",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9291",
  "ai-rendering-library": "/ai-rendering-library/static-1.10665",
  "chirp-fetch": "/chirp-fetch/static-1.2023",
  "connections-embed-lib": "/connections-embed-lib/static-1.1253",
  "copilot-toolkit": "/copilot-toolkit/static-1.11482",
  "feedback-loader": "/feedback-loader/static-1.29552",
  "laboratory-lib": "/laboratory-lib/static-3.7287",
  "marketplace-embed": "/marketplace-embed/static-1.22507",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10112",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20172",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14387",
  "sanitize-text": "/sanitize-text/static-1.8282",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8840",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5900",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5172",
  "wootric-nps": "/wootric-nps/static-1.7084",
  "quartz-head": "/quartz-head/static-1.876",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4786",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4285",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2582",
  "reporting-data": "/reporting-data/static-1.68103",
  "cssUtils": "/cssUtils/static-1.833",
  "flux-actions": "/flux-actions/static-1.349",
  "HubStyle": "/HubStyle/static-2.11913",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10342",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10497",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7476",
  "icons": "/icons/static-2.657",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18749",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4644",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5686",
  "quartz-i18n": "/quartz-i18n/static-1.886",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.73",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.501",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.634",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.798",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.91",
  "slack-ui-library": "/slack-ui-library/static-1.10532",
  "fsm": "/fsm/static-1.3866",
  "customer-data-objects": "/customer-data-objects/static-1.7814",
  "property-translator": "/property-translator/static-1.5532",
  "hs-locale-management": "/hs-locale-management/static-1.183",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8062",
  "hs-promise-utils": "/hs-promise-utils/static-1.5729",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5012",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13995",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5742",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7916",
  "sanitize": "/sanitize/static-1.4612",
  "superstore": "/superstore/static-1.4895",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10392",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8106",
  "hub-http-janus": "/hub-http-janus/static-1.849",
  "hubspotter-http": "/hubspotter-http/static-1.4753",
  "immutable-less": "/immutable-less/static-1.4787",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17624",
  "nav-meta": "/nav-meta/static-1.29968",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18177",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3948",
  "property-management-common": "/property-management-common/static-1.5902",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9203",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.548",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.886",
  "quartz-test": "/quartz-test/static-1.886",
  "quartz-tracking": "/quartz-tracking/static-1.590",
  "trellis-components": "/trellis-components/static-1.2240",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.202",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21956",
  "ContentUtils": "/ContentUtils/static-1.68760",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13164",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2633",
  "breeze-engine-core": "/breeze-engine-core/static-1.462",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.304",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40272",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13310",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14795",
  "ExportDialog": "/ExportDialog/static-6.10514",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41643",
  "reporting-snowflake": "/reporting-snowflake/static-1.56721",
  "reporting-ui-components": "/reporting-ui-components/static-2.65374",
  "reporting-visualizations": "/reporting-visualizations/static-1.60179",
  "trellis-theming": "/trellis-theming/static-1.1078",
  "ui-addon-teams": "/ui-addon-teams/static-1.21725",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.226",
  "magpie-lib": "/magpie-lib/static-1.5642",
  "navigation-components": "/navigation-components/static-1.18331",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1184",
  "magpie-types": "/magpie-types/static-1.5102",
  "simple-logging-lib": "/simple-logging-lib/static-1.3184",
  "ai-studio-lib": "/ai-studio-lib/static-1.12012",
  "app-governance-lib": "/app-governance-lib/static-1.1978",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10661",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18619",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8145",
  "ui-product-approvals": "/ui-product-approvals/static-1.28673",
  "ui-tool-access": "/ui-tool-access/static-1.10286",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9508",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5903",
  "usage-tracker-public": "/usage-tracker-public/static-1.7297",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3689",
  "persist-promise": "/persist-promise/static-1.3836",
  "reference-resolvers": "/reference-resolvers/static-1.8311",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4059",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.471",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3146",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3157",
  "atom": "/atom/static-1.5211",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6119",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1679",
  "crm-component-utils": "/crm-component-utils/static-1.39435",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6025",
  "customer-data-properties": "/customer-data-properties/static-1.52017",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7029",
  "property-value-citations": "/property-value-citations/static-1.2631",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8231",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9205",
  "navigation-messaging": "/navigation-messaging/static-1.7658",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10298",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4950",
  "content-icons-ui": "/content-icons-ui/static-1.2267",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9959",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7382",
  "crm-message-bus": "/crm-message-bus/static-1.43345",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22707",
  "events-data-lib": "/events-data-lib/static-1.370",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4857",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4107",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6934",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1117",
  "onboarding-tours": "/onboarding-tours/static-1.16865",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14068",
  "academy-common-lib": "/academy-common-lib/static-1.14255",
  "content-assistance-lib": "/content-assistance-lib/static-1.7971",
  "dashboard-lib": "/dashboard-lib/static-1.82052",
  "file-manager-components": "/file-manager-components/static-1.24023",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18789",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18611",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20069",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8839",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4895",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11212",
  "user-context": "/user-context/static-1.5243",
  "growth-payments-core": "/growth-payments-core/static-1.25774",
  "reporting-plugins": "/reporting-plugins/static-1.10534",
  "reporting-reports": "/reporting-reports/static-1.67781",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.861",
  "nest": "/nest/static-1.367",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10762",
  "framework-listing-lib": "/framework-listing-lib/static-2.29071",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31017",
  "apps-service-types": "/apps-service-types/static-1.3936",
  "oauth-service-types": "/oauth-service-types/static-1.4389",
  "content-media-capture": "/content-media-capture/static-1.4934",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23858",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10020",
  "video-components-external": "/video-components-external/static-1.11730",
  "video-data-lib": "/video-data-lib/static-1.35388",
  "react-dnd-compat": "/react-dnd-compat/static-1.4749",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.568",
  "onboarding-scopes": "/onboarding-scopes/static-1.6595",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5079",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7776",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15087",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3687",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9645",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6122",
  "signup-constants": "/signup-constants/static-1.19196",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8193",
  "card-properties-lib": "/card-properties-lib/static-1.44600",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37466",
  "crm-actions": "/crm-actions/static-1.6475",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43996",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9627",
  "customer-data-tracking": "/customer-data-tracking/static-1.7021",
  "hs-resources": "/hs-resources/static-1.313",
  "pulse": "/pulse/static-1.740",
  "calling-global-api": "/calling-global-api/static-1.64953",
  "calling-internal-common": "/calling-internal-common/static-1.31447",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66335",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58629",
  "commerce-products-lib": "/commerce-products-lib/static-1.10067",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3900",
  "crm-links": "/crm-links/static-1.6444",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4239",
  "external-options-client-types": "/external-options-client-types/static-1.4229",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4319",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.768",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3793",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49214",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4068",
  "smart-property-lib": "/smart-property-lib/static-1.7957",
  "tiered-pricing": "/tiered-pricing/static-1.1577",
  "topics-actions-lib": "/topics-actions-lib/static-1.221",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11126",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.148",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1235",
  "growth-data-modal": "/growth-data-modal/static-1.5655",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3201",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2306",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.931",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7773",
  "academy-service-client": "/academy-service-client/static-1.3819",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39522",
  "FileManagerLib": "/FileManagerLib/static-1.39663",
  "SafeStorage": "/SafeStorage/static-1.4535",
  "video-embed": "/video-embed/static-1.36222",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28936",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24670",
  "viral-links-lib": "/viral-links-lib/static-1.7205",
  "data-token-picker": "/data-token-picker/static-1.16650",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.374",
  "timezone-utils": "/timezone-utils/static-2.5378",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17907",
  "ui-addon-opt": "/ui-addon-opt/static-4.8497",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9512",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5457",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25726",
  "framework-data-table": "/framework-data-table/static-2.12222",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7001",
  "nudge-client-utils": "/nudge-client-utils/static-1.2875",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1271",
  "switchboard-lib": "/switchboard-lib/static-1.361",
  "app-users-service-client": "/app-users-service-client/static-1.5747",
  "app-users-service-types": "/app-users-service-types/static-1.5155",
  "mini-checkout-client": "/mini-checkout-client/static-1.27136",
  "onboarding-utils": "/onboarding-utils/static-1.5493",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28921",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12738",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4561",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6356",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5216",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
  "content-media-compositions": "/content-media-compositions/static-2.16745",
  "media-bridge-lib": "/media-bridge-lib/static-1.19165",
  "edison-service-client-types": "/edison-service-client-types/static-1.523",
  "crm_data": "/crm_data/static-4.92391",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46386",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17075",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4395",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1310",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19533",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18880",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10733",
  "crm-fe-perf": "/crm-fe-perf/static-1.23036",
  "event-emitter": "/event-emitter/static-1.1085",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.243",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31454",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11170",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6678",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1494",
  "commerce-permissions": "/commerce-permissions/static-1.910",
  "products-iframe-lib": "/products-iframe-lib/static-1.8305",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10682",
  "data-agent-kit": "/data-agent-kit/static-1.422",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10383",
  "policy-lib": "/policy-lib/static-1.6921",
  "react-tinymce": "/react-tinymce/static-1.55602",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10446",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54728",
  "tinymce-plugins": "/tinymce-plugins/static-1.57842",
  "tinymce-themes": "/tinymce-themes/static-1.56698",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2206",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2334",
  "user-context-client": "/user-context-client/static-1.4714",
  "audio-components": "/audio-components/static-1.6127",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37174",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4670",
  "video-components": "/video-components/static-1.13732",
  "outpost": "/outpost/static-1.4304",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6714",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21917",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3985",
  "ts-utils-lib": "/ts-utils-lib/static-1.309",
  "crm-export-dialog": "/crm-export-dialog/static-1.6419",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6576",
  "crm-view-components": "/crm-view-components/static-1.684",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7467",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2632",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2951",
  "whisper-core-api": "/whisper-core-api/static-1.6920",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15179",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5847",
  "settings-content-modals": "/settings-content-modals/static-1.46465",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22251",
  "customer-data-email": "/customer-data-email/static-1.18278",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37557",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39889",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12701",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55164",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21838",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18350",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72468",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5466",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9883",
  "utility-belt": "/utility-belt/static-1.2667",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23329",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7752",
  "customer-data-rte": "/customer-data-rte/static-1.33344",
  "cv-backend-services": "/cv-backend-services/static-1.1571",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5998",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5241",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38558",
  "trials-service-types": "/trials-service-types/static-1.4018",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36271",
  "sales-views-client-types": "/sales-views-client-types/static-1.4392",
  "hub-http-contrib": "/hub-http-contrib/static-1.3178",
  "interframe": "/interframe/static-3.4894",
  "tinymce-data": "/tinymce-data/static-1.40813",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5345",
  "layout-dnd-components": "/layout-dnd-components/static-1.12714",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11689",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15772",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9156",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7740",
  "social-insights-client-types": "/social-insights-client-types/static-1.22406",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4310",
  "checkout-sdk": "/checkout-sdk/static-3.23979",
  "company-details-components": "/company-details-components/static-1.6332",
  "payment-method-components": "/payment-method-components/static-1.7002",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14797",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3600",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3655",
  "access-control-lib": "/access-control-lib/static-1.10572",
  "EmailComponents": "/EmailComponents/static-1.55152",
  "EmailData": "/EmailData/static-1.53829",
  "redux-less": "/redux-less/static-2.9618",
  "sequences-lib": "/sequences-lib/static-1.8273",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10487",
  "products-ui-components": "/products-ui-components/static-1.40585",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7288",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55180",
  "commerce-products-api": "/commerce-products-api/static-1.2491",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57238",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103146",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81189",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28610",
  "ContentData": "/ContentData/static-1.68835",
  "layout-data-lib": "/layout-data-lib/static-1.10014",
  "checkout-service-types": "/checkout-service-types/static-1.3899",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.815",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4072",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4125",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.692",
  "pricing-pages-api": "/pricing-pages-api/static-1.14662",
  "ContentComponents": "/ContentComponents/static-2.71716",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10497",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2005",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46671",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1533",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19272",
  "automation-ui-types": "/automation-ui-types/static-1.20190",
  "messaging-types-lib": "/messaging-types-lib/static-1.46408",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4640",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8130",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.671",
  "price-books-api": "/price-books-api/static-1.1298",
  "price-books-components": "/price-books-components/static-1.1356",
  "property-description-translator": "/property-description-translator/static-1.3976",
  "ramp-editor": "/ramp-editor/static-1.511",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3711",
  "totals-ui-components": "/totals-ui-components/static-1.23962",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9436",
  "advanced-menus-core": "/advanced-menus-core/static-1.15357",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12265",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34410",
  "segments-query-core": "/segments-query-core/static-1.1555",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6106",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7473",
  "data-token-views": "/data-token-views/static-1.16631",
  "forms-utils-lib": "/forms-utils-lib/static-1.12842",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13316",
  "simple-menus-core": "/simple-menus-core/static-1.15356",
  "simple-menus-lib": "/simple-menus-lib/static-1.16873",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7029",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.34",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7645",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77477",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4057",
  "web-interactives-components": "/web-interactives-components/static-1.13999",
  "web-interactives-data": "/web-interactives-data/static-1.14000",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.982",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1152",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1112",
  "line-items-api": "/line-items-api/static-1.889",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3920",
  "FireAlarmUi": "/FireAlarmUi/static-1.4610",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4271",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22126",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21589",
  "data-studio-ubb": "/data-studio-ubb/static-1.3112",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27330",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58252",
  "content-management-data-lib": "/content-management-data-lib/static-1.5656",
  "copilot-plugins": "/copilot-plugins/static-1.11455",
  "cta-picker": "/cta-picker/static-1.36752",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3469",
  "editor-components": "/editor-components/static-1.13430",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8595",
  "error-messaging-js": "/error-messaging-js/static-1.5329",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86182",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10782",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1880",
  "smart-content-core": "/smart-content-core/static-1.42811",
  "smart-content-lib": "/smart-content-lib/static-1.43464",
  "social-composer-lib": "/social-composer-lib/static-1.59634",
  "structured-content-lib": "/structured-content-lib/static-1.25553",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53613",
  "tinymce-copilot": "/tinymce-copilot/static-1.16796",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8080",
  "automation-ui-routing": "/automation-ui-routing/static-1.21547",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5750",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42488",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3329",
  "reporting-enablement": "/reporting-enablement/static-1.23375",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21947",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3049",
  "forms-ai-lib": "/forms-ai-lib/static-1.4534",
  "codemirror-dlb": "/codemirror-dlb/static-1.59036",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6570",
  "report-customization-components": "/report-customization-components/static-1.13534",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13392",
  "reporting-filters": "/reporting-filters/static-1.658",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2140"
}
};
